import DateUtil from 'core/utilities/DateUtil'
import { CAPITAL_ONE_EXCLUSIVE_EVENT_TAG } from '../constants.js'

const getPrimaryPerformer = rawEvent => {
    return (rawEvent.performers || []).find(performer => performer.is_primary) || null
}

const imageUrlRectangle = (rawEvent, isIntegrated) => {
    if (isIntegrated && rawEvent.image) {
        return rawEvent.image
    }
    return ((rawEvent.images || {}).rectangle || {}).url || ''
}

const imageUrlSquare = (rawEvent, isIntegrated) => {
    if (isIntegrated && rawEvent.image) {
        return rawEvent.image + '?dimensions=612x612'
    }
    return ((rawEvent.images || {}).square || {}).url || ''
}

const hasGivenTaxonomy = (rawEvent, category) => {
    return (rawEvent.taxonomy || {}).segment === category
}

const pointsCurrency = rawEvent => {
    return rawEvent.loyalty_price ? rawEvent.loyalty_price.currency : null
}

const pointsPriceMin = rawEvent => {
    return rawEvent.loyalty_price ? rawEvent.loyalty_price.min : null
}

const parseEvent = (rawEvent, isIntegrated) => {
    const now = new Date()
    const schemaOrgUrlOrigin = window.location.origin
    const slug = rawEvent.seo_slug
    let localDateLabel = null

    try {
        const localDate = DateUtil.parse(rawEvent.local_date)

        if (DateUtil.areDatesEqual(localDate, now)) {
            // Note: Local times at or after 6:00PM are considered "Tonight",
            // earlier are "Today"
            localDateLabel = localDate.getHours() >= 18 ? 'Tonight' : 'Today'
        }
    } catch (err) {
        console.warn(`Could not parse ${rawEvent.local_date}`)
    }

    return {
        ...rawEvent,
        display_checkout_disclaimer: Boolean(rawEvent.disclaimer),
        disclaimer: rawEvent.disclaimer,
        imageUrlRectangle: imageUrlRectangle(rawEvent, isIntegrated),
        imageUrlSquare: imageUrlSquare(rawEvent, isIntegrated),
        isDateTbd: rawEvent.is_date_tbd,
        isExpired: rawEvent.is_expired,
        isMusic: hasGivenTaxonomy(rawEvent, 'music'),
        isSports: hasGivenTaxonomy(rawEvent, 'sports'),
        isTheater: hasGivenTaxonomy(rawEvent, 'arts & theatre'),
        isExclusive: hasGivenTaxonomy(rawEvent, CAPITAL_ONE_EXCLUSIVE_EVENT_TAG),
        isPartnerExclusive: rawEvent.is_exclusive,
        isTimeTbd: rawEvent.is_time_tbd,
        localDate: rawEvent.local_date,
        localDateLabel,
        moneyCurrency: rawEvent.price.currency,
        moneyPriceMin: rawEvent.price.min,
        numListings: rawEvent.ticket_quantity || 0,
        pointsCurrency: pointsCurrency(rawEvent),
        pointsPriceMin: pointsPriceMin(rawEvent),
        schemaOrgUrl: `${schemaOrgUrlOrigin}/${slug || `events/${rawEvent.id}`}`,
        slug,
        venueCity: (rawEvent.venue || {}).city_name || '',
        venueName: (rawEvent.venue || {}).name || '',
        venueRegionCode: (rawEvent.venue || {}).subdivision || ''
    }
}

export {
    getPrimaryPerformer,
    parseEvent
}
